import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";

import { Pedido } from '@app/models/pedido.model';
import { PedidoService } from '@app/services/pedido.service';


@Component({
  selector: 'app-pedido-form',
  templateUrl: './pedido-form.component.html'
})
export class PedidoFormComponent implements OnInit {

  titulo: string;
  lstErros: string[];
  pedido: Pedido = new Pedido();
  aguardandoSolicitacao: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private pedidoService: PedidoService) { }

  ngOnInit() {
    let id = this.route.params.subscribe(params => {
      let id = params['id'];
      this.titulo = id ? 'Editar Pedido' : 'Novo Pedido';

      if (!id)
        return;

      this.pedidoService.obterPorId(id).toPromise().then(
        data => this.pedido = data,
        () => this.router.navigate(['./configuracoes/pedidos']));
    });
  }

  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.pedidoService.gravar(this.pedido).toPromise().then(
      () => this.router.navigate(["./configuracoes/pedido"]),
      (data: any) => {
        if (data.error){
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
      });
  }
}
